import React, { useState } from 'react';
import { SidebarsIconTooltip } from '../Sidebar/sidebarTooltip/SidebarsIconTooltip';
import { circleColor, IconProps, strokeColor } from './icons.utils';

export const TeamAnalyticsIcon: React.FC<IconProps> = ({
  active,
  className = '',
  tooltip = '',
}: IconProps): JSX.Element => {
  const [hover, setIsHover] = useState(false);

  const onEnter = () => {
    setIsHover(true);
  };

  const onLeave = () => {
    setIsHover(false);
  };

  const circleFill = hover && !active ? '#cdd5e5' : circleColor(active);

  const underscore = active ? (
    <rect
      x="7.9"
      y="23.5"
      width="8.34831"
      height="1.9"
      rx="1.0254"
      fill={strokeColor(active)}
    />
  ) : (
    <></>
  );

  return (
    <div
      className="sidebar__nav-link__icon__wrapper"
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >
      <SidebarsIconTooltip isActive={hover} label={tooltip} />

      <svg
        width="22"
        height="15"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <circle
          cx="12"
          cy="12.5"
          r="12"
          fill={circleFill}
          style={active ? {} : { transitionDuration: '0.1s', opacity: '0.2' }}
        />
        {active ? (
          <g clipPath="url(#clip0_303_15515)">
            <path
              d="M5 5.58333C5 5.26117 5.26117 5 5.58333 5C5.9055 5 6.16667 5.26117 6.16667 5.58333V17.8333H18.4167C18.7388 17.8333 19 18.0945 19 18.4167C19 18.7388 18.7388 19 18.4167 19H5.58333C5.26117 19 5 18.7388 5 18.4167V5.58333ZM17.8333 7.91667C17.8333 7.69572 17.7085 7.49373 17.5109 7.39492C17.3133 7.29611 17.0768 7.31743 16.9 7.45L12.5442 10.7169L9.57356 8.96943C9.4032 8.86922 9.1937 8.86209 9.01692 8.95047L6.94444 9.9867V17.0556H17.8333L17.8333 7.91667Z"
              fill="#CDD5E5"
            />
          </g>
        ) : (
          <path
            d="M5.00009 5.58333C5.00009 5.26117 5.26126 5 5.58343 5C5.90559 5 6.16676 5.26117 6.16676 5.58333V10.4505L9.00621 8.95602C9.18493 8.86196 9.39958 8.86703 9.57366 8.96943L12.5443 10.7169L16.9001 7.45C17.0769 7.31743 17.3134 7.29611 17.511 7.39492C17.7086 7.49373 17.8335 7.69572 17.8335 7.91667V17.8333H18.4168C18.7389 17.8333 19.0001 18.0945 19.0001 18.4167C19.0001 18.7388 18.7389 19 18.4168 19H5.58343C5.26126 19 5.00009 18.7388 5.00009 18.4167V11.4277C4.99997 11.4207 4.99997 11.4136 5.00009 11.4067V5.58333ZM6.16676 11.7689V17.8333H16.6668V9.08333L12.9335 11.8833C12.7452 12.0245 12.4905 12.0388 12.2877 11.9195L9.26212 10.1397L6.16676 11.7689Z"
            fill="#CDD5E5"
          />
        )}
        {underscore}
      </svg>
    </div>
  );
};
